import { useState, useEffect } from 'react';
import axiosInstance from '../services/axiosComman';


const UseGetData = ({page="", pageCount="", url,param={}}) => {
  const [data, setData] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [isLoading, setLoading] = useState(true)

  async function getData(hasValue=false) {
    !data && setLoading(true)
    let params;
    if(page == "" && pageCount == ""){
       params = {}
    }
    else if(hasValue==true) {
      params={
        page: page,
        per_page: pageCount,
      }
    }
    else{
      params = {
        page: page,
        per_page: pageCount,
        ...param
      }
    }
    try {
      const res = await axiosInstance.get(url, { params });
      if(res.data?.data){
        setLoading(false)
        setData(res?.data?.data);
        (res?.data?.total_record||res?.data?.total) ? setTotalCount(res?.data?.total_record||res?.data?.total):setTotalCount(0)
      }else{
        setLoading(false)
        console.log(res.data?.msg||res.data?.error);
        
      }
    } catch (error) {
      setLoading(false)
      console.log(error);
    }
  }
  useEffect(() => {
    if(url||page||pageCount)getData();
  }, [url,page,pageCount]);

  return { data, totalCount , getData,isLoading };
};

export default UseGetData;